import './RegionSelector.scss';
import React from 'react';
import { SelectButtonList, SelectButtonItem } from '~/components/SelectButtonList';

export type RegionOption = {
    name: string;
    slug: string | undefined;
};

type RegionSelectorProps = {
    regions: RegionOption[];
    selected?: string;
    onRegionClick?: (region: RegionOption) => unknown;
};

export default class RegionSelector extends React.Component<RegionSelectorProps> {
    regionButton(region: RegionOption) {
        const { selected, onRegionClick } = this.props;
        const isSelected = region.slug === selected;
        return (
            <SelectButtonItem key={region.slug ?? ''} isSelected={isSelected} onSelect={() => onRegionClick?.(region)}>
                {region.name}
            </SelectButtonItem>
        );
    }

    render() {
        return (
            <div className="regionSelector">
                <SelectButtonList legend="Region">
                    {this.props.regions.map((f) => this.regionButton(f))}
                </SelectButtonList>
            </div>
        );
    }
}
